import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";
import task05 from "./layouts/task-05/task";
import task06 from "./layouts/task-06/task";

const lesson: Lesson = {
  id: "a28ca02b-d688-4058-9d7e-4a499c7a9393",
  publicId: "12",
  name: "Sound Source Localization",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [principle01, task01, task02, task03, task04, task05, task06],
};

export default lesson;
